import React from "react";

export default function AdPerformanceSection() {
  return (
    <section className="w-full max-w-4xl mx-auto">
      {/* Heading */}
      <header className="mb-8">
        <div className="font-bebas font-normal tracking-wider text-[30px]  lg:text-[50px] text-center leading-[130%] text-[#06382f]">
          Why Traditional Ad Performance
          <br className="hidden sm:block" /> Is{" "}
          <span className="text-[red]">Flattening</span>
        </div>

        <div className="mt-4 text-[12px] text-center text-[#004D4D] sm:text-sm lg:text-lg font-inter font-normal leading-[100%]">
          Evidence-backed reasons your old units underperform
        </div>
      </header>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-stretch">
        {/* Display Fatigue */}
        <div className="flex flex-col justify-between bg-white/80 rounded-2xl ring-1 ring-black/5 py-3 px-3 h-[330px] lg:h-[360px]">
          <div className="flex items-center gap-3 text-[30px] lg:text-[40px] font-normal font-bebas leading-[100%] text-[#06382f]">
            <span className="inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-sky-100 text-[orangered]">
              <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor">
                <path d="M10.29 3.86a2 2 0 0 1 3.42 0l8.2 13.73A2 2 0 0 1 20.2 21H3.8a2 2 0 0 1-1.71-3.41l8.2-13.73zM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1zm0 8a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 12 16z" />
              </svg>
            </span>
            Display Fatigue
          </div>

          <div>
            <div className="font-inter text-[26px] lg:text-[35px] font-bold  text-[orangered] leading-[130%]">
              0.16%
            </div>
            <div className="font-inter text-base lg:text-lg font-medium leading-[150%] text-[#004D4D]">
              avg. display CTR
            </div>
            <div className="font-inter text-[12px] lg:text-sm font-normal leading-[150%] text-[#004D4D]">
              Source: IAB 2024
            </div>
          </div>

          <div>
            <div className="font-inter text-[26px] lg:text-[35px] font-bold  text-[orangered] leading-[130%]">
              92% banner blindness
            </div>
            <div className="font-inter text-base lg:text-lg font-medium leading-[150%] text-[#004D4D]">
              ignored by readers
            </div>
            <div className="font-inter text-[12px] lg:text-sm font-normal leading-[150%] text-[#004D4D]">
              Source: NNI Group, 0024
            </div>
          </div>

          <div className="bg-[#004D4D] text-[white] px-3 py-3 rounded-2xl text-sm font-medium flex items-center leading-[130%]">
            Net Effect: Lower engagement and declining CTR
          </div>
        </div>

        {/* Video Ad Challenges */}
        <div className="flex flex-col justify-between bg-white/80 rounded-2xl ring-1 ring-black/5 py-3 px-3 h-[330px] lg:h-[360px]">
          <div>
            <div className="flex items-center gap-3 text-[30px] lg:text-[40px] font-normal font-bebas leading-[100%] text-[#06382f]">
              <span className="inline-flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded-full bg-sky-100 text-[orangered]">
                <svg
                  viewBox="0 0 24 24"
                  className="w-5 h-5"
                  fill="currentColor"
                >
                  <path d="M10.29 3.86a2 2 0 0 1 3.42 0l8.2 13.73A2 2 0 0 1 20.2 21H3.8a2 2 0 0 1-1.71-3.41l8.2-13.73zM12 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1zm0 8a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 12 16z" />
                </svg>
              </span>
              Video Ad Challenges
            </div>

            <ul className="mt-7 space-y-6 text-base lg:text-lg font-medium font-inter text-[#004D4D] leading-[130%] list-disc pl-5">
              <li>IAB restricts autoplay/sound-on</li>
              <li>Stricter MRC viewability enforcement by Google</li>
              <li>
                Publishers seeing{" "}
                <span className="text-base lg:text-lg text-[orangered] font-inter font-medium leading-[100%]">
                  20 – 40% ↓
                </span>{" "}
                fill/CPM on video units
              </li>
            </ul>
          </div>

          <div className="bg-[#004D4D] text-[white] px-3 py-3 rounded-2xl text-sm font-medium flex items-center leading-[130%]">
            Net Effect: Less monetizable inventory at lower yield
          </div>
        </div>
      </div>

      <div className="mt-5 md:mt-8 text-left md:text-center  text-[#004D4D] text-base lg:text-[17px] font-inter font-medium leading-[120%]">
        <span className="font-bold">Content-based</span>,{" "}
        <span className="font-bold">interaction-first</span> formats are now
        required to meet buyer expectations for Premium CPM.
      </div>
    </section>
  );
}
